import interact from 'interact.js';
import initSlider from '../utils/slider';
import { MUSTS_SLIDER_HOMEPAGE, MERCH_SLIDER_HOMEPAGE } from '../constants/settings';
import { manageZIndex, dragHandler, resizeHandler } from '../utils/interact';
import Subnav from 'global/subnav';

class Homepage {
  constructor(home) {
    this.wrapper          = home;
    this.mustsSlider      = this.setupMustsSlider();
    this.merchSlider      = this.setupMerchSlider();
    this.activeMuseboard  = this.setupMuseboardInteract();

    this.museboardsSubnav = new Subnav('museboards', this.elems);
  }

  setupMustsSlider() {
    let $slickEl = $(this.wrapper).find('.slick-musts');
    initSlider($slickEl, MUSTS_SLIDER_HOMEPAGE)
  }

  setupMerchSlider() {
    let $slickEl = $(this.wrapper).find('.slick-merch');
    initSlider($slickEl, MERCH_SLIDER_HOMEPAGE)
  }

  setupMuseboardInteract() {
    interact('.js-mb-light-interactable')
    .draggable({
      onstart: manageZIndex,
      onmove: dragHandler,
      inertia: true,
      restrict: {
        restriction: 'parent',
        elementRect: {
          top: 0,
          left: 0,
          bottom: 1,
          right: 1,
        }
      },
    })
    .resizable({
      onmove: resizeHandler,
      preserveAspectRatio: true,
      inertia: true,
      invert: 'none',
      edges: { top: true, right: true, bottom: true, left: true },
      restrict: {
        resize: 'parent',
      }
    });

    $('.js-mb-light-interactable').on('touchstart', (e) => {
      if (e.originalEvent.changedTouches.length > 1) e.preventDefault();
    });
  }

}

export default Homepage;



// WEBPACK FOOTER //
// ./app/javascript/homepage/index.js